import { appHttpClient } from "../../installations/http/axiosInterfaces";
import { dedupeRequest } from "../../installations/http/inFlight";

// 0024: read-only analytics. The JWT is attached by the axios request interceptor, so
// scope is derived SERVER-SIDE from the token — these calls carry NO scope params.
// dedupeRequest collapses StrictMode double-invokes into one network request (0015/0016).

export const getAdminSummary = () =>
  dedupeRequest("analytics:adminSummary", () =>
    appHttpClient.get(`/Analytics/AdminSummary`)
  );

export const getAgentSummary = () =>
  dedupeRequest("analytics:agentSummary", () =>
    appHttpClient.get(`/Analytics/AgentSummary`)
  );

const analyticsService = {
  getAdminSummary,
  getAgentSummary,
};

export default analyticsService;
